import React from 'react';
import { useEffect, useState} from 'react';
import { useDispatch, useSelector} from 'react-redux';
import DataTable from 'react-data-table-component';
import { 
  Paper,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '../components/Tooltip';
import { getFlowReport } from '../Redux/FlowDucks';
import { getFlowReportExcel } from '../Redux/FlowDucks';
import { fetchFlowsFromAPI } from '../Redux/FlowDucks';
import Skeleton from '../components/Skeleton';


// const flowDataList = [
//     { id: 1, name: 'Pablo Toledo', number: '56945243881', status: true, lastNode: 'dnd_node_12ssssssssssssssssssssssssasdasdasd312444', tries: 1, duration: "20:04:30", answered:"3/3" },
//     { id: 2, name: 'Carlitos ¨-¨', number: '56931241511', status: false, lastNode: 'dnd_node_122214', tries: 5, duration: "20:04:30", answered:"3/5" },
//     { id: 3, name: 'Animales wtf', number: '56933218941', status: false, lastNode: 'dnd_node_1421224', tries: 3, duration: "20:04:30", answered:"0/5" },
//     { id: 4, name: 'Patricio A', number: '56955234567', status: true, lastNode: 'dnd_node_123155523', tries: 1, duration: "20:04:30", answered:"5/5" },
//     { id: 5, name: 'uwu', number: '56912453897', status: false, lastNode: 'dnd_node_322166674', tries: 8, duration: "20:04:30", answered:"2/3" },
// ]



const FlowAnalizePage = () => {
    const [flowId, setFlowId] = useState(null);
    const [flowList, setFlowList] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [loading, setLoading] = useState(false);
    // Inicializar fechas: hoy y 4 meses antes
    const today = React.useMemo(() => {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    }, []);
    const fourMonthsAgo = React.useMemo(() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 2);
      return d.toISOString().slice(0, 10);
    }, []);
    const [startDate, setStartDate] = useState(fourMonthsAgo);
    const [endDate, setEndDate] = useState(today);
    const dispatch = useDispatch();

    const Data = useSelector(store => store.flow.flowReport) || [];
    const flow = useSelector(store => store.flow.flowList)

    const [flowData, setFlowData] = useState([]);


    // Buscar datos según filtros actuales
    const handleSearch = () => {
      setLoading(true);
      dispatch(getFlowReport(flowId, startDate, endDate));
      // setFlowData(Data); // Data se actualizará por Redux
    };

    const handleDownload = () => {
      dispatch(getFlowReportExcel(flowId, startDate, endDate));
      // setFlowData(Data); // Data se actualizará por Redux
    };


    useEffect(() => {
        if (flowList.length < 1) {  
          dispatch(fetchFlowsFromAPI("0"));
        }
    }, []);

    useEffect(() => {
        if (flow) {
            setFlowList(flow);
        }
    }, [flow]);

    const handleChangeOption = (event) => {
      const { value } = event.target;
      setFlowId(value);
    };


    useEffect(() => {
      setFlowData(Data);
      setLoading(false);
    }, [Data]);

    const filteredItems = flowData.filter(
        item => (item.number && item.number.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
    );

    const columns = [
        {
        name: 'ID',
        selector: row => row.id,
        width: '80px',
        sortable: true,
        },
        {
        name: 'Nombre',
        selector: row => row.name,
        cell: row => 
          <Tooltip content={row.name}>
            <span className="truncate-text">
              {row.name.slice(0, 40)}
              {row.lastNode.length > 40 ? "..." : ""}
            </span>
          </Tooltip>, 
        sortable: true,
        },
        {
        name: 'Número',
        selector: row => row.number,
        sortable: true,
        },
        {
        name: 'Flujo Terminado',
        selector: row => row.status? "Completado" : "Sin Completar",
        sortable: true,
        },
        {
        name: 'Último Nodo',
        selector: row => row.lastNode,
        cell: row => 
          <Tooltip content={row.lastNode}>
            <span className="truncate-text">
              {row.lastNode.slice(0, 40)}
              {row.lastNode.length > 40 ? "..." : ""}
            </span>
          </Tooltip>, 
        sortable: true,
        },
        {
        name: 'Intentos',
        selector: row => row.tries,
        maxWidth: '200px',
        sortable: true,
        },
        {
        name: 'Duración',
        selector: row => row.duration,
        sortable: true,
        },
        {
        name: 'Respondido',
        selector: row => row.answered,
        sortable: true,
        }
    ]

  const CustomLoader = () => (
    <div style={{ padding: '24px', width: '100%' }}>
      {Array.from({ length: 10 }).map((_, idx) => (
        <React.Fragment key={idx}>
          <Skeleton width='100%' height='2rem' />
          <br />
        </React.Fragment>
      ))}
    </div>
  );

    
    const subHeaderComponentMemo = React.useMemo(() => {
        return (
          <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
            <FormControl variant="outlined" className="apple-select" sx={{ ml: 2, width: '300px'}} >
              <InputLabel id="business-line-label">Flujo de mensaje</InputLabel>
              <Select
                labelId="business-line-label"
                label="Línea de Negocio"
                value={flowId}
                onChange={handleChangeOption}
              >
                <MenuItem value={"0"}>Todos</MenuItem>
                {flowList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
              <FormControl variant="outlined" sx={{ ml: 2, width: '180px' }}>
              <InputLabel shrink htmlFor="start-date" sx={{ backgroundColor: 'white' }}>
                Fecha Inicio
              </InputLabel>
              <input
                id="start-date"
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                style={{
                  padding: '16.5px 14px',
                  borderRadius: 4,
                  border: '1px solid #c4c4c4',
                  fontSize: '16px',
                  fontFamily: 'inherit',
                  background: 'white'
                }}
              />
            </FormControl>
            <FormControl variant="outlined" sx={{ ml: 2, mr:2, width: '180px' }}>
              <InputLabel shrink htmlFor="end-date" sx={{ backgroundColor: 'white' }}>
                Fecha Término
              </InputLabel>
              <input
                id="end-date"
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                style={{
                  padding: '16.5px 14px',
                  borderRadius: 4,
                  border: '1px solid #c4c4c4',
                  fontSize: '16px',
                  fontFamily: 'inherit',
                  background: 'white'
                }}
              />
            </FormControl>
            <div className="apple-search-container">
              <SearchIcon className="apple-search-icon" />
              <input
                type="text"
                placeholder="Buscar por nombre o numero"
                onChange={e => setFilterText(e.target.value)}
                className="apple-search-input"
              />
            </div>
            <Button
              variant="contained"
              onClick={handleSearch}
              sx={{ ml: 2 }}
            >
              Buscar
            </Button>
            < Button
              variant="contained"
              onClick={handleDownload}
              sx={{ ml: 2 }}
              color='success'
            >
              Descargar
            </Button>
            </Box>
            
          </Box>
        );
      }, [filterText, flowId, flowList, startDate, endDate]);

    return (
        <div className="apple-container" >
            <Paper className="apple-card">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20, 30]}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  progressPending={loading}
                  progressComponent={<CustomLoader />}
                  persistTableHead
                  customStyles={customStyles}
                />
            </Paper>
        
        </div>
    );
}

const customStyles = {
  table: {
    style: {
      minWidth: '80vw',
      maxWidth: '90vw'
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F2F2F7',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#86868B',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      fontSize: '14px',
      color: '#1D1D1F',
    },
  },
};

export default FlowAnalizePage;